export class AuditLogSource {
    Code: string;
    Name: string;
}